import React, { useState, useEffect } from 'react';
import LocationSelectorBase from './LocationSelectorBase';
import { BuildingSVG } from './BuildingSVG';
import { fetchWithRetry } from '../utils/tourUtils';
import { API_BASE_URL } from '../config';
import { FUNCTION_NAMES } from '../constants';
import { Card } from './ui/card';

const LotBuildingSelectorWithSVG = ({
  clientId,
  projectId,
  onSpaceSelect,
  tourMap = {},
  checklistMap = {},
  customSettings = null,
  canDeleteSpace = true,
}) => {
  const confirmDelete = () =>
    window.confirm('Are you sure you want to delete this space and all its tours and images?');

  const [selection, setSelection] = useState({
    lotId: '',
    buildingId: '',
    floorId: '',
    spaceId: '',
    floors: [],
    spaces: [],
  });

  const handleDeleteSpace = async spaceId => {
    if (!confirmDelete()) return;

    try {
      await fetchWithRetry({
        url: `${API_BASE_URL}/api/post`,
        data: {
          function_name: FUNCTION_NAMES.PRISMA,
          operation: 'space.deleteSpaceAndTours',
          payload: { spaceId },
        },
        label: 'delete_space_and_tours',
      });
      // Step 4. Refresh spaces/floors locally
      setSelection(prev => ({
        ...prev,
        spaces: prev.spaces.filter(space => space.id !== spaceId),
      }));
    } catch (error) {
      console.error('Failed to delete space and tours:', error);
      alert('Failed to delete. Please try again.');
    }
  };

  const handleLocationChange = updated => {
    setSelection(updated);
    if (updated.selectedSpace) {
      onSpaceSelect?.(updated.selectedSpace);
    }
  };

  const handleSpaceClick = spaceId => {
    handleLocationChange({
      ...selection,
      selectedSpace: spaceId,
    });
  };

  return (
    <div className="flex flex-col h-full max-h-[calc(100vh-100px)] overflow-hidden">
      <div className="flex flex-col lg:flex-row mb-4 space-y-4 lg:space-y-0 lg:space-x-4">
        <div className="flex-1">
          <LocationSelectorBase
            clientId={clientId}
            projectId={projectId}
            lotId={selection.lotId}
            buildingId={selection.buildingId}
            floorId={selection.floorId}
            spaceId={selection.spaceId}
            onChange={handleLocationChange}
            hideFloorSpace={true} // Important: we don't need full floor selector
          />
        </div>
      </div>

      {selection.lotId && selection.buildingId && (
        <div className="flex-1 flex-grow min-h-0 overflow-hidden">
          <Card className="h-full shadow-md border">
            <div className="h-full flex flex-col">
              <BuildingSVG
                floors={selection.floors}
                spaces={selection.spaces}
                selectedSpace={selection.spaceId}
                onSpaceClick={handleSpaceClick}
                tourMap={tourMap}
                checklistMap={checklistMap}
                onDeleteSpace={canDeleteSpace ? handleDeleteSpace : null}
                customSettings={customSettings}
                canDeleteSpace={canDeleteSpace}
              />
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default LotBuildingSelectorWithSVG;
